var _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 86,
    viewBox: "0 0 272 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_2271_49514)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2408 7H48.5694L50.2551 8.68572V16.3919L48.5694 18.0776L50.2551 19.7633V27.4694L48.5694 29.1552H34.2408L34 24.098H34.8429V12.0572H34L34.2408 7ZM41.5857 12.0572V16.2715L43.5123 15.549V12.0572H41.5857ZM41.5857 21.3286V24.098H43.5123V20.6062L41.5857 21.3286Z",
    fill: "url(#paint0_linear_2271_49514)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8901 7H87.2187L87.4595 14.8266H82.4023L82.1615 12.0572H80.235V16.2715L82.1615 15.549V20.6062L80.235 21.3286V24.098H81.0778L80.837 29.1552H72.8901L72.6492 24.098H73.4921V12.0572H72.6492L72.8901 7Z",
    fill: "url(#paint1_linear_2271_49514)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.685 7H90.3568L90.116 12.0572H90.9589V24.098H90.116L90.3568 29.1552H98.3038L98.5446 24.098H97.7017V21.3286L99.6283 20.6062V15.549L97.7017 16.2715V12.0572H99.6283L99.8691 14.8266H104.926L104.685 7Z",
    fill: "url(#paint2_linear_2271_49514)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.86 20.6062L114.933 21.3286V24.098H115.295L115.054 29.1552H107.588L107.348 24.098H108.19V8.68572L109.876 7H121.917L123.603 8.68572V24.098H124.446L124.205 29.1552H116.739L116.499 24.098H116.86V20.6062ZM114.933 16.2715L116.836 15.549V12.0572H114.933V16.2715Z",
    fill: "url(#paint3_linear_2271_49514)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.283 7H127.336L127.095 12.0572H127.938V24.098H127.095L127.336 29.1552H141.665L141.906 21.3286H136.849L136.608 24.098H134.681V12.0572H135.524L135.283 7Z",
    fill: "url(#paint4_linear_2271_49514)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.248 7H158.265L159.95 8.68572H159.975V27.4694L158.289 29.1552H146.248L144.562 27.4694V8.68572L146.248 7ZM151.305 24.098H153.232V12.0572H151.305V24.098Z",
    fill: "url(#paint5_linear_2271_49514)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.822 41.6218C235.361 40.9297 230.404 39.4298 230.404 39.4298L231.327 37.9455C229.756 38.1881 228.543 38.3834 226.716 39.2939L226.716 39.2944C226.715 39.2947 226.714 39.295 226.714 39.2954L226.713 39.2959L226.712 39.2963C223.747 40.8484 222.309 42.3235 221.845 43.5945C221.75 43.8549 221.695 44.1057 221.678 44.3477C221.606 45.2961 222.088 46.0968 222.84 46.6839C223.871 47.4923 225.41 47.8992 226.717 47.7355C226.717 47.7355 224.296 50.0426 220.838 48.889C219.653 48.4579 218.695 47.6352 218.058 46.608C215.611 42.6573 217.101 36.2675 224.35 33.5762C224.35 33.5762 214.498 18.2029 201.358 12.6658L180.38 18.8956L183.031 20.7413L166.894 26.2785L168.162 27.0863L142.573 38.2756C142.573 38.2756 143.841 43.582 138.423 50.5046C138.423 50.5046 142.112 50.0426 146.262 43.3519C146.262 43.3519 143.61 56.7339 134.734 57.6568L131.535 76H142.83L141.009 72.6419C141.009 72.6419 140.195 66.7596 140.496 66.1944C141.265 64.7522 142.034 64.5118 144.936 63.6038C145.517 63.4221 146.183 63.2138 146.951 62.9638C147.884 62.6603 148.902 62.4985 149.996 62.3246C154.309 61.6389 159.81 60.7646 165.97 50.2745C165.97 50.2745 164.702 56.5038 163.088 58.4651C166.776 58.1188 169.888 63.4252 169.888 63.4252L183.338 63.0996L181.646 50.2745L187.117 64.6737L191.347 64.6191L197.646 75.9994L207.004 75.8838L203.985 72.5393L201.933 65.2709L206.894 63.5527L209.31 67.6931L210.578 64.5782L214.496 71.9616L216.341 68.9617C216.341 68.9617 223.372 72.3074 224.525 72.3074C225.678 72.3074 236.051 60.1946 238.126 53.6196C238.126 53.6196 236.282 42.3146 235.821 41.6213L235.822 41.6218ZM226.62 58.0411C226.62 58.0411 225.478 58.9776 224.35 58.117C224.35 58.117 224.378 58.5873 224 59.076C224 59.076 223.108 55.1302 224.462 53.8959C224.462 53.8959 226.901 55.1201 227.682 59.0132C227.682 59.0132 227.15 58.0304 226.62 58.0411Z",
    fill: "url(#paint6_linear_2271_49514)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.778 63.9585C150.778 63.9585 156.172 63.8583 158.507 61.4355V61.4349L164.817 72.4231L168.852 75.9995L157.027 75.4859L150.778 63.9585Z",
    fill: "url(#paint7_linear_2271_49514)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.451 65.3327V75.9995H186.286L183.882 72.5388L183.99 65.3327H175.451Z",
    fill: "url(#paint8_linear_2271_49514)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8483 7.24082H53.1421L52.9013 12.298H53.7442V27.4694L55.4299 29.1552H67.4707L69.1565 27.4694V12.298H69.9993L69.7585 7.24082H62.0524L61.8115 12.298H62.4136V24.098H60.487V12.298H61.0891L60.8483 7.24082Z",
    fill: "url(#paint9_linear_2271_49514)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.9 32.4161H103.317L102.843 47.8126H110.66L111.134 42.3646H113.976V66.0515H112.318L112.792 76H128.425L128.899 66.0515H127.241V42.3646H130.083L130.557 47.8126H138.374L137.9 32.4161Z",
    fill: "url(#paint10_linear_2271_49514)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3775 32.4161H98.565L99.0387 47.8126H89.0902L88.6165 42.3646H84.8266V50.655L88.6165 49.2338V59.1823L84.8266 60.6035V66.0515H88.6165L89.0902 60.6035H99.0387L98.565 76H70.3775L69.9038 66.0515H71.5619V42.3646H69.9038L70.3775 32.4161Z",
    fill: "url(#paint11_linear_2271_49514)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8033 32.4161H34.6159L34.1421 42.3646H35.8002V66.0515H34.1421L34.6159 76H62.8033L66.1195 72.6838V57.5242L62.8033 54.208L66.1195 50.8919V35.7323L62.8033 32.4161ZM49.0649 50.655V42.3646H52.8548V49.2338L49.0649 50.655ZM49.0649 66.0515V60.6035L52.8548 59.1823V66.0515H49.0649Z",
    fill: "url(#paint12_linear_2271_49514)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.06,
    clipPath: "url(#clip0_2271_49514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.3998 5H41.6885L65.2884 42.0004L41.6885 79H53.3998L76.9997 42.0004L53.3998 5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.556 5H20.8447L44.4439 42.0004L20.8447 79H32.556L56.156 42.0004L32.556 5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7113 5H0L23.5992 42.0004L0 79H11.7113L35.3104 42.0004L11.7113 5Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.06,
    clipPath: "url(#clip1_2271_49514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.6 5H230.312L206.712 42.0004L230.312 79H218.6L195 42.0004L218.6 5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.444 5H251.155L227.556 42.0004L251.155 79H239.444L215.844 42.0004L239.444 5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.289 5H272L248.401 42.0004L272 79H260.289L236.69 42.0004L260.289 5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_2271_49514",
    x: 25.8627,
    y: 0.490196,
    width: 220.4,
    height: 85.2745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.62745
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.06863
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2271_49514"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2271_49514",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.813725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect2_innerShadow_2271_49514"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2271_49514",
    x1: 136.063,
    y1: 7,
    x2: 136.063,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2271_49514",
    x1: 136.063,
    y1: 7,
    x2: 136.063,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2271_49514",
    x1: 136.063,
    y1: 7,
    x2: 136.063,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2271_49514",
    x1: 136.063,
    y1: 7,
    x2: 136.063,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2271_49514",
    x1: 136.063,
    y1: 7,
    x2: 136.063,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2271_49514",
    x1: 136.063,
    y1: 7,
    x2: 136.063,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2271_49514",
    x1: 136.063,
    y1: 7,
    x2: 136.063,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2271_49514",
    x1: 136.063,
    y1: 7,
    x2: 136.063,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2271_49514",
    x1: 136.063,
    y1: 7,
    x2: 136.063,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2271_49514",
    x1: 136.063,
    y1: 7,
    x2: 136.063,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2271_49514",
    x1: 136.063,
    y1: 7,
    x2: 136.063,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2271_49514",
    x1: 136.063,
    y1: 7,
    x2: 136.063,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2271_49514",
    x1: 136.063,
    y1: 7,
    x2: 136.063,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2271_49514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 74,
    fill: "white",
    transform: "translate(0 5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2271_49514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 74,
    fill: "white",
    transform: "matrix(-1 0 0 1 272 5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default ForwardRef;